
import { createTheme, ThemeProvider } from "@mui/material/styles";
const theme = createTheme({
    palette: {
      primary: {
        main: '#f98f19',
      },
      secondary: {
        main: '#f95819',
      },
    },
  });

  export default theme;